import { ECountries } from '@/_types';
import { DOMAIN_ZONE_BY_COUNTRY, WB_STAGE_COUNTRIES } from '../../_constants';

export const getHostnameByCountry = (
  currentHostname: string,
  country: string,
): string => {
  const isSellerHostname =
    currentHostname.includes('.wb.') ||
    currentHostname.includes('.wildberries.');

  if (!isSellerHostname) return currentHostname;

  const nextCountry = country.toLowerCase() as ECountries;
  const nextDomainZone = DOMAIN_ZONE_BY_COUNTRY[nextCountry];

  if (!nextDomainZone) return currentHostname;

  if (!currentHostname.includes('stage')) {
    return `seller.wildberries.${nextDomainZone}`;
  }

  return WB_STAGE_COUNTRIES.has(nextCountry)
    ? `seller-portal-stage.wb.${nextDomainZone}`
    : `seller.portal-stage.wildberries.${nextDomainZone}`;
};
